// extracted by mini-css-extract-plugin
module.exports = {"root":"UserGroupTitle_root__3kUvk"};